import { render, staticRenderFns } from "./userPlan.vue?vue&type=template&id=5fba80e0&scoped=true&"
import script from "./userPlan.vue?vue&type=script&lang=js&"
export * from "./userPlan.vue?vue&type=script&lang=js&"
import style0 from "./userPlan.vue?vue&type=style&index=0&id=5fba80e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fba80e0",
  null
  
)

export default component.exports